import { motion, useInView } from 'framer-motion';
import { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import partyImage from '../public/catgory/party.png';
import sportsImage from '../public/catgory/sports.png';
import conferenceImage from '../public/catgory/conference.png';
import musicImage from '../public/catgory/music.png';
import workshopImage from '../public/catgory/workshop.png';
import theatreImage from '../public/catgory/theatre.png';
import cookingImage from '../public/catgory/health.png';
import healthImage from '../public/catgory/health.png';
import festivalImage from '../public/catgory/festival.png';
import Navbar from '../components/navabar';
import Footer from '../components/footer';
import FestivalImage from '../public/FestivalImage.png';
import { Link } from 'react-router-dom';

const CategoryPage = () => {
  // Get category from URL params
  const { categoryName } = useParams();
  const [activeCategory, setActiveCategory] = useState('All');
  const [selectedState, setSelectedState] = useState('');
  const [selectedCity, setSelectedCity] = useState('');
  const [selectedDate, setSelectedDate] = useState('');
  const [availableCities, setAvailableCities] = useState([]);

  const eventsInLagosRef = useRef(null);
  const moreSportsEventsRef = useRef(null);

  const isEventsInLagosInView = useInView(eventsInLagosRef, { once: true, amount: 0.3 });
  const isMoreSportsEventsInView = useInView(moreSportsEventsRef, { once: true, amount: 0.3 });
  
  // Nigerian states and cities data
  const nigerianStates = [
    'Abia', 'Adamawa', 'Akwa Ibom', 'Anambra', 'Bauchi', 'Bayelsa', 
    'Benue', 'Borno', 'Cross River', 'Delta', 'Ebonyi', 'Edo',
    'Ekiti', 'Enugu', 'FCT', 'Gombe', 'Imo', 'Jigawa',
    'Kaduna', 'Kano', 'Katsina', 'Kebbi', 'Kogi', 'Kwara',
    'Lagos', 'Nasarawa', 'Niger', 'Ogun', 'Ondo', 'Osun',
    'Oyo', 'Plateau', 'Rivers', 'Sokoto', 'Taraba', 'Yobe', 'Zamfara'
  ];

  const stateCities = {
    'Lagos': ['Lagos Island', 'Ikeja', 'Victoria Island', 'Lekki'],
    'FCT': ['Garki', 'Wuse', 'Maitama', 'Asokoro'],
    'Rivers': ['Port Harcourt', 'Bonny', 'Eleme', 'Okrika'],
    // Add more states and cities as needed
  };

  // Update available cities when state changes
  useEffect(() => {
    if (selectedState && stateCities[selectedState]) {
      setAvailableCities(stateCities[selectedState]);
      setSelectedCity('');
    } else {
      setAvailableCities([]);
      setSelectedCity('');
    }
  }, [selectedState]);

  // Convert URL param to proper category name format
  const formatCategoryName = (param) => {
    return param
      .split('-')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  const category = formatCategoryName(categoryName);

  console.log('Current category:', category);

  const categoryConfigs = {
    'Parties': {
      bgColor: '#3A010A',
      heading: 'The Party Starts Here!',
      subheading: 'From night clubs to exclusive parties, discover and book your next unforgettable night out.',
      image: partyImage
    },
    'Sports': {
      bgColor: '#264748',
      heading: 'Feel the Thrill of the Game',
      subheading: 'From football to racing, find matches, tournaments, and sports events happening around you.',
      image: sportsImage
    },
    'Conference': {
      bgColor: '#36383C',
      heading: 'Learn, Connect, and Grow',
      subheading: 'Attend insightful conferences, network with industry leaders, and gain new knowledge.',
      image: conferenceImage
    },
    'Music Concert': {
      bgColor: '#160D0E',
      heading: 'Feel the Beat, Live the Moment',
      subheading: 'Experience electrifying performances from your favorite artists. Get your tickets now!',
      image: musicImage
    },
    'Workshop': {
      bgColor: '#4A505C',
      heading: 'Learn, Create, and Master Your Craft',
      subheading: 'Join hands-on workshops to build new skills and explore your passion.',
      image: workshopImage
    },
    'Theatre': {
      bgColor: '#280005',
      heading: 'Experience the Magic of Live Performance',
      subheading: 'Discover plays, musicals, and drama productions that bring stories to life.',
      image: theatreImage
    },
    'Cooking': {
      bgColor: '#354E2C',
      heading: 'Cook, Taste, and Enjoy',
      subheading: 'Join cooking classes, food challenges, and master the art of great cuisine.',
      image: cookingImage
    },
    'Health': {
      bgColor: '#415671',
      heading: 'Wellness Starts Here',
      subheading: 'Attend health talks, fitness sessions, and medical conferences for a better you.',
      image: healthImage
    },
    'Festival': {
      bgColor: '#174143',
      heading: 'Celebrate Culture, Music & Art',
      subheading: 'Find the biggest festivals happening near you and be part of the excitement.',
      image: festivalImage
    },
    'default': {
      bgColor: '#3A010A',
      heading: 'Explore Amazing Events',
      subheading: 'Discover and book your next unforgettable experience.',
      image: partyImage
    }
  };

  // Event data for Lagos events section
  const lagosEvents = [
    {
      id: 1,
      title: "The Lagos Festival 2025",
      location: "Lagos Oriental Hotel Victoria Island",
      date: "Sun, 11 Jun",
      time: "11:00am",
      interested: 90,
      admission: "Free",
      status: "available",
      image: FestivalImage
    },
    {
      id: 2,
      title: "The Lagos Festival 2025",
      location: "Lagos Oriental Hotel Victoria Island",
      date: "Sun, 11 Jun",
      time: "11:00am",
      interested: 90,
      admission: "Free",
      status: "sold_out",
      image: FestivalImage
    },
    {
      id: 3,
      title: "The Lagos Festival 2025",
      location: "Lagos Oriental Hotel Victoria Island",
      date: "Sun, 11 Jun",
      time: "11:00am",
      interested: 90,
      admission: "Free",
      status: "limited",
      remainingTickets: 5,
      image: FestivalImage
    },
    {
      id: 4,
      title: "The Lagos Festival 2025",
      location: "Lagos Oriental Hotel Victoria Island",
      date: "Sun, 11 Jun",
      time: "11:00am",
      interested: 90,
      admission: "Free",
      status: "available",
      image: FestivalImage
    },
    {
      id: 5,
      title: "The Lagos Festival 2025",
      location: "Lagos Oriental Hotel Victoria Island",
      date: "Sun, 11 Jun",
      time: "11:00am",
      interested: 90,
      admission: "Free",
      status: "sold_out",
      image: FestivalImage
    },
    {
      id: 6,
      title: "The Lagos Festival 2025",
      location: "Lagos Oriental Hotel Victoria Island",
      date: "Sun, 11 Jun",
      time: "11:00am",
      interested: 90,
      admission: "Free",
      status: "available",
      image: FestivalImage
    }
  ];

  // More sports events data (9 events)
  const sportsEvents = [
    {
      id: 7,
      title: "Lagos Marathon 2025",
      location: "Teslim Balogun Stadium",
      date: "Sat, 15 Jun",
      time: "07:00am",
      interested: 120,
      admission: "₦2,500",
      status: "available",
      image: FestivalImage
    },
    {
      id: 8,
      title: "Beach Volleyball Championship",
      location: "Elegushi Beach",
      date: "Sun, 18 Jun",
      time: "10:00am",
      interested: 75,
      admission: "Free",
      status: "available",
      image: FestivalImage
    },
    {
      id: 9,
      title: "Lagos Boxing Night",
      location: "Eko Convention Center",
      date: "Fri, 24 Jun",
      time: "07:00pm",
      interested: 110,
      admission: "₦5,000",
      status: "limited",
      remainingTickets: 20,
      image: FestivalImage
    },
    {
      id: 10,
      title: "Inter-School Swimming Gala",
      location: "Ikoyi Club",
      date: "Mon, 26 Jun",
      time: "09:00am",
      interested: 65,
      admission: "Free",
      status: "available",
      image: FestivalImage
    },
    {
      id: 11,
      title: "Lagos Tennis Cup",
      location: "Lagos Lawn Tennis Club",
      date: "Wed, 28 Jun",
      time: "02:00pm",
      interested: 85,
      admission: "₦3,000",
      status: "available",
      image: FestivalImage
    },
    {
      id: 12,
      title: "Basketball All-Stars Weekend",
      location: "National Stadium",
      date: "Sat, 1 Jul",
      time: "11:00am",
      interested: 140,
      admission: "₦2,000",
      status: "sold_out",
      image: FestivalImage
    },
    {
      id: 13,
      title: "Lagos Sailing Regatta",
      location: "Lagos Yacht Club",
      date: "Sun, 2 Jul",
      time: "12:00pm",
      interested: 70,
      admission: "₦10,000",
      status: "limited",
      remainingTickets: 10,
      image: FestivalImage
    },
    {
      id: 14,
      title: "Corporate Football League",
      location: "Campos Mini Stadium",
      date: "Sat, 8 Jul",
      time: "04:00pm",
      interested: 95,
      admission: "Free",
      status: "available",
      image: FestivalImage
    },
    {
      id: 15,
      title: "Lagos Cycling Tour",
      location: "Lekki-Epe Expressway",
      date: "Sun, 9 Jul",
      time: "06:30am",
      interested: 110,
      admission: "₦1,500",
      status: "available",
      image: FestivalImage
    }
  ];

  // Get the configuration for the current category or use default
  const config = categoryConfigs[category] || categoryConfigs['default'];

  // Event card variants
  const cardVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 0.1,
        duration: 0.6,
        ease: "easeOut"
      }
    }),
    hover: {
      y: -10,
      boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
      transition: {
        type: "spring",
        stiffness: 400,
        damping: 15
      }
    }
  };

  // Button animation variants
  const buttonVariants = {
    hover: {
      scale: 1.05,
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      transition: { duration: 0.3 }
    },
    tap: {
      scale: 0.95,
      transition: { duration: 0.2 }
    }
  };

  // Badge variants
  const badgeVariants = {
    initial: { scale: 0 },
    animate: { scale: 1, transition: { type: "spring", stiffness: 500, damping: 17 } }
  };

  // New scroll animation variants
  const fadeInUpVariants = {
    hidden: { opacity: 0, y: 60 },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: { duration: 0.8, ease: "easeOut" }
    }
  };

  // Handle date selection with calendar
  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  // Handle form submission for finding events
  const handleFindEvent = (e) => {
    e.preventDefault();
    // Add logic to filter events based on selection
    console.log("Finding events with:", {
      state: selectedState,
      city: selectedCity,
      date: selectedDate
    });
  };


  const sectionTitles = {
    'Parties': 'Party Events In Lagos',
    'Sports': 'Sports Events In Lagos',
    'Conference': 'Conference Events In Lagos',
    'Music Concert': 'Music Concert Events In Lagos',
    'Workshop': 'Workshop Events In Lagos',
    'Theatre': 'Theatre Events In Lagos',
    'Cooking': 'Cooking Events In Lagos',
    'Health': 'Health Events In Lagos',
    'Festival': 'Festival Events In Lagos',
    'default': 'Events In Lagos'
  };

  const moreSectionTitles = {
    'Parties': 'More Party Events',
    'Sports': 'More Sports Events',
    'Conference': 'More Conference Events',
    'Music Concert': 'More Music Concerts',
    'Workshop': 'More Workshops',
    'Theatre': 'More Theatre Events',
    'Cooking': 'More Cooking Events',
    'Health': 'More Health Events',
    'Festival': 'More Festivals',
    'default': 'More Events'
  };

  return (
    <>
      <Navbar />
      <motion.div 
        className="relative overflow-hidden"
        style={{ backgroundColor: config.bgColor }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        {/* Hero content container */}
        <div className="relative z-10 mx-auto lg:px-8">
          <div className="flex flex-col md:flex-row items-center justify-center py-16 text-white">
            {/* Text content (left side) */}
            <div className="w-full md:w-1/2 px-4 md:px-1 mb-8 md:mb-0">
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.2 }}
              >
                <motion.h1 
                  className="text-4xl sm:text-5xl md:text-5xl font-bold mb-6"
                  initial={{ x: -50 }}
                  animate={{ x: 0 }}
                  transition={{ type: 'spring', stiffness: 100 }}
                >
                  {config.heading}
                </motion.h1>
                <motion.p 
                  className="text-lg sm:text-xl md:text-2xl mb-8 md:mb-12"
                  initial={{ x: -50 }}
                  animate={{ x: 0 }}
                  transition={{ type: 'spring', stiffness: 100, delay: 0.1 }}
                >
                  {config.subheading}
                </motion.p>
              </motion.div>
            </div>

            {/* Image slider (right side) */}
            <div className="w-full md:w-1/2 px-4 md:px-6 relative">
              <motion.div 
                className="relative rounded-lg overflow-hidden shadow-2xl"
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.8, delay: 0.3 }}
                whileHover={{ scale: 1.02 }}
              >
                <motion.img 
                  src={config.image}
                  alt={category}
                  className="w-full h-auto object-cover"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ duration: 1 }}
                />
                <motion.div 
                  className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent opacity-50"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 0.5 }}
                  transition={{ duration: 1 }}
                />
              </motion.div>
            </div>
          </div>
        </div>
      </motion.div>

      {/* Search filters section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <form onSubmit={handleFindEvent} className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          {/* State dropdown */}
          <div className="relative w-full sm:w-auto">
            <select 
              className="appearance-none rounded-full w-full px-6 py-3 border border-gray-300 bg-white text-gray-700 pr-8 leading-tight focus:outline-none focus:ring-2 focus:ring-yellow-400"
              value={selectedState}
              onChange={(e) => setSelectedState(e.target.value)}
            >
              <option value="">State</option>
              {nigerianStates.map((state) => (
                <option key={state} value={state}>{state}</option>
              ))}
            </select>
            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
              <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
              </svg>
            </div>
          </div>
          
          {/* City dropdown */}
          <div className="relative w-full sm:w-auto">
            <select 
              className="appearance-none rounded-full w-full px-6 py-3 border border-gray-300 bg-white text-gray-700 pr-8 leading-tight focus:outline-none focus:ring-2 focus:ring-yellow-400"
              value={selectedCity}
              onChange={(e) => setSelectedCity(e.target.value)}
              disabled={!selectedState || availableCities.length === 0}
            >
              <option value="">City</option>
              {availableCities.map((city) => (
                <option key={city} value={city}>{city}</option>
              ))}
            </select>
            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
              <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
              </svg>
            </div>
          </div>
          
          {/* Date picker */}
          <div className="relative w-full sm:w-auto">
            <input 
              type="date" 
              className="appearance-none rounded-full w-full px-6 py-3 border border-gray-300 bg-white text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-yellow-400"
              value={selectedDate}
              onChange={handleDateChange}
            />
          </div>
          
          {/* Find event button */}
          <motion.button
            variants={buttonVariants}
            whileHover="hover"
            whileTap="tap"
            type="submit"
            className="w-full sm:w-auto px-8 py-3 bg-black text-white font-medium rounded-full hover:bg-gray-800 transition-colors"
          >
            Find event
          </motion.button>
        </form>
      </div>

      {/* Sports Events In Lagos Section */}
      <div ref={eventsInLagosRef} className="py-12 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          variants={fadeInUpVariants}
          initial="hidden"
          animate={isEventsInLagosInView ? "visible" : "hidden"}
        >
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-8">
  {sectionTitles[category] || sectionTitles['default']}
</h2>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {lagosEvents.map((event, i) => (
              <Link to={`/single-event/${event.id}`} key={event.id} className="block">
                <motion.div
                  custom={i}
                  variants={cardVariants}
                  initial="hidden"
                  animate={isEventsInLagosInView ? "visible" : "hidden"}
                  whileHover="hover"
                  className="bg-white rounded-xl overflow-hidden shadow-lg group relative h-80 sm:h-96"
                >
                  {/* Status badge */}
                  {event.status === "sold_out" && (
                    <motion.div
                      variants={badgeVariants}
                      initial="initial"
                      animate="animate"
                      className="absolute top-4 right-4 z-20 bg-red-500 text-white px-2 py-1 rounded text-xs font-semibold"
                    >
                      Sold out
                    </motion.div>
                  )}
                  
                  {event.status === "limited" && (
                    <motion.div
                      variants={badgeVariants}
                      initial="initial"
                      animate="animate"
                      className="absolute top-4 right-4 z-20 bg-orange-500 text-white px-2 py-1 rounded text-xs font-semibold"
                    >
                      {event.remainingTickets} Tickets remaining
                    </motion.div>
                  )}

                  {/* Card image */}
                  <div className="absolute inset-0 w-full overflow-hidden">
                    <img 
                      src={event.image} 
                      alt={event.title}
                      className="w-full h-full object-cover transition-transform duration-500 ease-in-out group-hover:scale-110"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent opacity-60"></div>
                  </div>
                  
                  {/* Card content */}
                  <div className="absolute bottom-0 left-0 right-0 p-4 bg-transparent">
                    <h3 className="text-lg sm:text-xl font-medium mb-1 truncate text-white">{event.title}</h3>
                    <p className="text-sm text-gray-200 mb-1 truncate">{event.location}</p>
                    
                    <div className="flex items-center justify-between mb-2">
                      <div className="text-gray-200 text-xs sm:text-sm truncate">
                        <span>{event.date} • {event.time}</span>
                      </div>
                      
                      <div className="flex items-center space-x-1 text-yellow-300 text-xs">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-3 h-3">
                          <path fillRule="evenodd" d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.007 5.404.433c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.433 2.082-5.006z" clipRule="evenodd" />
                        </svg>
                        <span>{event.interested} Interested</span>
                      </div>
                    </div>
                    
                    <div className="flex items-center justify-between">
                      <div className="text-white font-medium">
                        Admission: {event.admission}
                      </div>
                      
                      {event.status === "sold_out" ? (
                        <span className="text-red-400 font-medium text-xs px-3 py-1">Sold out</span>
                      ) : (
                        <motion.button
                          variants={buttonVariants}
                          whileHover="hover"
                          whileTap="tap"
                          className="px-3 py-1 bg-[#FCD20B] text-gray-900 rounded-full text-xs sm:text-sm font-medium"
                        >
                          Get Ticket
                        </motion.button>
                      )}
                    </div>
                  </div>
                </motion.div>
              </Link>
            ))}
          </div>
        </motion.div>
      </div>

      {/* More Sports Events Section */}
      <div ref={moreSportsEventsRef} className="py-12 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            variants={fadeInUpVariants}
            initial="hidden"
            animate={isMoreSportsEventsInView ? "visible" : "hidden"}
          >
        
<h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-8">
  {moreSectionTitles[category] || moreSectionTitles['default']}
</h2>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {sportsEvents.map((event, i) => (
                <Link to={`/single-event/${event.id}`} key={event.id} className="block">
                  <motion.div
                    custom={i}
                    variants={cardVariants}
                    initial="hidden"
                    animate={isMoreSportsEventsInView ? "visible" : "hidden"}
                    whileHover="hover"
                    className="bg-white rounded-xl overflow-hidden shadow-lg group relative h-80 sm:h-96"
                  >
                    {/* Status badge */}
                    {event.status === "sold_out" && (
                      <motion.div
                        variants={badgeVariants}
                        initial="initial"
                        animate="animate"
                        className="absolute top-4 right-4 z-20 bg-red-500 text-white px-2 py-1 rounded text-xs font-semibold"
                      >
                        Sold out
                      </motion.div>
                    )}
                    
                    {event.status === "limited" && (
                      <motion.div
                        variants={badgeVariants}
                        initial="initial"
                        animate="animate"
                        className="absolute top-4 right-4 z-20 bg-orange-500 text-white px-2 py-1 rounded text-xs font-semibold"
                      >
                        {event.remainingTickets} Tickets remaining
                      </motion.div>
                    )}

                    {/* Card image */}
                    <div className="absolute inset-0 w-full overflow-hidden">
                      <img 
                        src={event.image} 
                        alt={event.title}
                        className="w-full h-full object-cover transition-transform duration-500 ease-in-out group-hover:scale-110"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent opacity-60"></div>
                    </div>
                    
                    {/* Card content */}
                    <div className="absolute bottom-0 left-0 right-0 p-4 bg-transparent">
                      <h3 className="text-lg sm:text-xl font-medium mb-1 truncate text-white">{event.title}</h3>
                      <p className="text-sm text-gray-200 mb-1 truncate">{event.location}</p>
                      
                      <div className="flex items-center justify-between mb-2">
                        <div className="text-gray-200 text-xs sm:text-sm truncate">
                          <span>{event.date} • {event.time}</span>
                        </div>
                        
                        <div className="flex items-center space-x-1 text-yellow-300 text-xs">
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-3 h-3">
                            <path fillRule="evenodd" d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.007 5.404.433c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.433 2.082-5.006z" clipRule="evenodd" />
                          </svg>
                          <span>{event.interested} Interested</span>
                        </div>
                      </div>
                      
                      <div className="flex items-center justify-between">
                        <div className="text-white font-medium">
                          Admission: {event.admission}
                        </div>
                        
                        {event.status === "sold_out" ? (
                          <span className="text-red-400 font-medium text-xs px-3 py-1">Sold out</span>
                        ) : (
                          <motion.button
                            variants={buttonVariants}
                            whileHover="hover"
                            whileTap="tap"
                            className="px-3 py-1 bg-[#FCD20B] text-gray-900 rounded-full text-xs sm:text-sm font-medium"
                          >
                            Get Ticket
                          </motion.button>
                        )}
                      </div>
                    </div>
                  </motion.div>
                </Link>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
      <Footer/>
    </>
  );
};

export default CategoryPage;